import { FC } from "react";
import { pluralizeWithCount } from "@common/helpers/string";
import { CommandsListProps } from "./lib";
import { TaskBulkOptionsCommandsList } from "./TaskBulkOptionsCommandsList";
import { useCommands } from "./useCommands";

export const TransactionBulkCategoryCommandsList: FC<CommandsListProps> = ({
    options = {},
}) => {
    const { returnToRoot } = useCommands();
    const {
        selectedTransactionCount = 0,
        transactionBulkCategoryOptions = [],
    } = options;

    return (
        <TaskBulkOptionsCommandsList
            heading={`Set category for ${pluralizeWithCount("transaction", selectedTransactionCount)}`}
            options={transactionBulkCategoryOptions}
            onOptionSelected={returnToRoot}
        />
    );
};
